var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 87,
    viewBox: "0 0 90 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tool-02-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.8 19.9445L38.7 39.007M19.8 19.9445H7.2L3 7.23611L7.2 3L19.8 7.23611V19.9445ZM75.4878 6.139L64.4519 17.2699C62.7887 18.9475 61.9567 19.7862 61.6454 20.7535C61.3712 21.6043 61.3712 22.5207 61.6454 23.3716C61.9567 24.3388 62.7887 25.1775 64.4519 26.8551L65.4481 27.8602C67.1113 29.5378 67.9433 30.3765 68.9022 30.6908C69.7456 30.9672 70.6544 30.9672 71.4978 30.6908C72.4567 30.3765 73.2887 29.5378 74.9519 27.8602L85.2751 17.4482C86.3868 20.1769 87 23.1656 87 26.2986C87 39.1662 76.6579 49.5972 63.9 49.5972C62.362 49.5972 60.8588 49.4456 59.4052 49.1563C57.3631 48.7504 56.3421 48.5471 55.7234 48.6094C55.0653 48.6755 54.7411 48.775 54.1581 49.0898C53.6096 49.3859 53.0598 49.9404 51.9594 51.0502L21.9 81.3681C18.4206 84.8773 12.7794 84.8773 9.3 81.3681C5.82059 77.8589 5.82059 72.169 9.3 68.6598L39.3594 38.3419C40.4598 37.232 41.0096 36.6773 41.3032 36.1242C41.6152 35.5362 41.7139 35.2092 41.7794 34.5455C41.8412 33.9213 41.6396 32.8916 41.2372 30.8323C40.9504 29.3658 40.8 27.8499 40.8 26.2986C40.8 13.4311 51.1421 3 63.9 3C68.1231 3 72.0816 4.14299 75.4878 6.139ZM45.0004 58.0691L68.1 81.3677C71.5793 84.8769 77.2207 84.8769 80.7 81.3677C84.1793 77.8585 84.1793 72.1685 80.7 68.6593L61.6963 49.4926C60.351 49.3643 59.0393 49.1194 57.7714 48.7682C56.1371 48.3158 54.3446 48.6445 53.1467 49.8527L45.0004 58.0691Z",
    stroke: "#D09AFF",
    strokeWidth: 5.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/tool.819cebb7a91021846df505a138c49c25.svg";
export { ForwardRef as ReactComponent };